var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ErrorMessage, HelpMessage, LoadingMessage, SuccessMessage, } from "./InfoMessages";
import { digitsToHindi } from "@bale/utils";
import clsx from "clsx";
import styles from "./BaseTextFieldFrame.module.scss";
/** @internal */
export const BaseTextFieldset = (_a) => {
    var { isFocus, isError, isSuccess, isLoading, fieldWrapperClassName, label } = _a, props = __rest(_a, ["isFocus", "isError", "isSuccess", "isLoading", "fieldWrapperClassName", "label"]);
    return (React.createElement("fieldset", Object.assign({ className: clsx("field-wrapper", styles.FieldWrapper, {
            [styles.isFocus]: isFocus,
            [styles.hasError]: isError,
            [styles.hasSuccess]: isSuccess,
            [styles.hasLoading]: isLoading,
        }, fieldWrapperClassName) }, props),
        label && React.createElement("legend", { className: styles.label }, label),
        props.children));
};
/** @interal  */
export const BaseTextFieldFrame = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: clsx(props.className, styles.wrapper, {
            [styles.disabled]: props.disabled,
        }), onClick: props.onWrapperClick, style: props.style, ref: ref },
        props.children,
        (props.showMaxLength ||
            props.errorText ||
            props.helpText ||
            props.successText ||
            props.loadingText) && (React.createElement("div", { className: styles.MessageWrapper },
            React.createElement("div", { className: styles.messages, "aria-label": "input-status" },
                props.errorText && React.createElement(ErrorMessage, { message: props.errorText }),
                props.successText && (React.createElement(SuccessMessage, { message: props.successText })),
                props.helpText && React.createElement(HelpMessage, { message: props.helpText }),
                props.loadingText && (React.createElement(LoadingMessage, { message: props.loadingText }))),
            props.showMaxLength && (React.createElement("div", { className: styles.max }, props.formatNumber
                ? props.formatNumber(`${(_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0}/${props.maxLength}`) + " "
                : digitsToHindi(`${(_d = (_c = props.value) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0}/${props.maxLength}`) + " "))))));
});
//# sourceMappingURL=BaseTextFieldFrame.js.map